module.exports = __webpack_public_path__ + "static/ft-worth-c600f664737ea7c1251648ad40e97508.png";